import React from 'react'

const OutputStatusIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
    >
      <circle cx='16' cy='16' r='16' fill='#6267AC' />
      <path
        d='M19.3333 19.3332L22.6667 15.9998L19.3333 12.6665L18.3933 13.6065L20.1133 15.3332H14V16.6665H20.1133L18.3933 18.3932L19.3333 19.3332Z'
        fill='white'
      />
      <path
        d='M20.6667 20.6667H11.3333V11.3333H20.6667V12.6667H22V11.3333C22 10.9797 21.8595 10.6406 21.6095 10.3905C21.3594 10.1405 21.0203 10 20.6667 10H11.3333C10.6 10 10 10.6 10 11.3333V20.6667C10 21.4 10.6 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V19.3333H20.6667V20.6667Z'
        fill='white'
      />
    </svg>
  )
}

export default OutputStatusIcon
